import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { PrintBookingsRangeSheetBase } from './PrintBookingsRangeSheet'

import { dataSelector } from 'reduxModules/selectors/ModalSelectors'

const mapStateToProps = createStructuredSelector({
  data: dataSelector
})

export const PrintBookingsRangeSheet = connect(mapStateToProps)(PrintBookingsRangeSheetBase)


// WEBPACK FOOTER //
// ./src/components/EnhancedModal/components/PrintBookingsRangeSheet/index.js